import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Introduction } from 'Components/frameworks/introduction/Introduction';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
type Props = {
  config: CMSContent;
  hasShadow?: boolean;
  icon?: string;
  id?: string;
  smallTitle: string;
  subTitle: string;
  text: string;
  title: string;
};
export const TitleAndTextLine = ({
  config,
  hasShadow,
  icon,
  id,
  smallTitle,
  subTitle,
  text,
  title,
}: Props) => (
  <SiteContainer
    className={classnames('Line', {
      'Line-Introduction border-b-1 border-t-1 border-lightGrey shadow-md': hasShadow,
      'Line-TitleAndText': !hasShadow,
    })}
    id={id}
  >
    <Introduction
      className={hasShadow ? 'py-20' : ''}
      iconName={icon}
      isTextSeeMoreCollapseEnabled
      small={smallTitle}
      seeMoreLabel={config.common.viewMore}
      seeLessLabel={config.common.loadLess}
      subtitle={subTitle}
      text={text}
      title={title}
    />
  </SiteContainer>
);
